<script>
import BrokerageNav from '@components/admin/brokerage-nav'
import BrokerageInfo from '@components/admin/brokerage-info'
import AdminLayout from '@layouts/admin-main'

export default {
  page: {
    title: 'Admin::BrokerageView',
    meta: [{ name: 'description', content: 'Admin::BrokerageView' }],
  },
  components: { AdminLayout, BrokerageNav, BrokerageInfo },
}
</script>

<template>
  <AdminLayout>
    <BrokerageNav></BrokerageNav>
    <BrokerageInfo :brokerage_seq="$route.params.brokerage_seq"></BrokerageInfo>
  </AdminLayout>
</template>
